import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning, BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    BymoPagePropsSpecialContentSettingMetadata
} from '../../client-server-common';
import {asArray, immerProduce} from '@wix/devzai-utils-common';
import {WixImageResource, wixMediaResourceReplaceExternalImage} from '@wix/devzai-common-wix';
import {DoppeDtoContactMethod} from '../../client-server-common/types/doppe-dto-contact-method';
import {DoppeActionFullName} from '../../client-server-common/types/doppe-action-full-name';

export namespace DoppeActionTypeSaveContact {

    export interface ActionSettings {
        media: WixImageResource | null;
        name: DoppeActionFullName;
        jobTitle: string;
        contactMethods: DoppeDtoContactMethod[];
        company: string;
        notes: string;
    }
}

export const doppeActionTypeSaveContact = doppeActionTypeDefineMetadata<DoppeActionTypeSaveContact.ActionSettings>({
    id: 'io.bymo.action/save-contact',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        contactMethods: [],
        media: null,
        name: {
            firstName: '',
            lastName: ''
        },
        jobTitle: '',
        company: '',
        notes: '',
    }),
    resolveUsedMedia: actionSettings => {
        return actionSettings.media ? asArray(actionSettings.media) : [];
    },
    resolveMainMedia: actionSettings => {
        return actionSettings.media;
    },
    replaceExternalImages: (actionSettings, externalImagesUrlToImageResourceMap) => {
        return immerProduce(actionSettings, actionSettings => {
            if (actionSettings.media) {
                actionSettings.media = wixMediaResourceReplaceExternalImage(actionSettings.media, externalImagesUrlToImageResourceMap)
            }
        })
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            media: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.SingleImage, BymoPagePropsContentSettingSemanticMeaning.EntityMedia),
            name: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.PersonFullName, BymoPagePropsContentSettingSemanticMeaning.PersonName),
            jobTitle: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.PersonJobTitle),
            contactMethods: BymoPagePropsSpecialContentSettingMetadata.Unknown,
            company: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityCompany),
            notes: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
    notSupportsSearch: true,
});
